import React from 'react';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { Box } from '@mui/material';
import MultiYearsComparison from './MultiYearsComparison/MultiYearsComparison';
import RatiosExplanation from './RatiosExplanation/RatiosExplanation';
import BudgetBalance from './BudgetBalance/BudgetBalance';
import Flex from 'ui/Flex/Flex';
import BudgetReportToggle from '../../shared/BudgetReportToggle/BudgetReportToggle';

type Props = {
    budgetProposals: BudgetProposalT[];
    selectedBudgetName: string | null;
    year: string;
};

export default function FinanceRatios({
    budgetProposals,
    selectedBudgetName,
    year,
}: Props): React.ReactElement {
    const referenceYear: number = parseInt(year, 10);
    const years: number[] = [
        referenceYear,
        referenceYear - 1,
        referenceYear - 2,
        referenceYear - 3,
    ];

    return (
        <Box
            sx={{
                padding: '3rem',
                paddingTop: '1rem',
            }}
        >
            <Flex direction="row" justifyContent="end">
                <BudgetReportToggle
                    exercice={referenceYear}
                    context={{
                        page: 'Synthèse du budget et ratios',
                        budgetProposal: selectedBudgetName || '',
                    }}
                />
            </Flex>
            <BudgetBalance
                budgetName={selectedBudgetName}
                budgetProposals={budgetProposals}
                referenceYear={referenceYear}
            />
            <MultiYearsComparison
                budgetName={selectedBudgetName}
                years={years}
                referenceYear={referenceYear}
            />
            <RatiosExplanation />
        </Box>
    );
}
